<template>
   <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
         <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
         <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <Header :drawer="$store.state.drawer"></Header>
      <v-content>
         <v-container>
            <v-card>
               <v-card-title class="justify-center">
                  VUNET Application Form Fees Payment
               </v-card-title
                  >
               <v-card-text>
                  <v-simple-table fixed-header width="500px">
                     <template>
                        <thead>
                           <tr color="red">
                              <th class="text-left">Application Number</th>
                              <th class="text-left">Program/Course</th>
                              <th class="text-left">Application Date</th>
                              <th class="text-left">Open</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>1222222</td>
                              <td>LLM</td>
                              <td>2 JUNE 2021</td>
                              <td>Open</td>
                           </tr>
                        </tbody>
                     </template>
                  </v-simple-table>
                  <div class="mt-5">
                     <v-row justify="center">
                        <v-col class="d-flex" cols="12" md="4">
                           <v-select
                              required
                              v-model="CategoryType"
                              :rules="[(v) => !!v || 'required']"
                              readonly
                              prepend-inner-icon="mdi-lock"
                              label="Category Type*"
                              return-object
                              outlined
                              ></v-select>
                        </v-col>
                     </v-row>
                     <v-row justify="center">
                        <v-col cols="12" md="4">
                           <v-select
                              required
                              v-model="fess"
                              :rules="[(v) => !!v || 'required']"
                              prepend-inner-icon="mdi-lock"
                              label="Applicable Fees in RS*"
                              return-object
                              outlined
                              ></v-select>
                        </v-col>
                     </v-row>
                  </div>
                  <v-row justify="center">
                     <v-col cols="12" md="8">
                        <label>Note:</label>
                        <p>
                           1.You are suggested to use NAtionalized Bank
                           Credentials(Debit/Credit Card)to make payment of fees
                        </p>
                        <p>
                           2.The Payment receipt will be generated and will emailed to
                           you within 24 hours after successfully payment transaction.
                        </p>
                        <p>
                           3.In case of payment failure/error,kindly contact VU's
                           counselling and Admissions office.<br />
                           We will let you know the status and will arrange for payment
                           receipt(as applicable)
                        </p>
                     </v-col>
                  </v-row>
                  <v-row justify="center">
                     <button class="mr-4 test">Pay Fees</button>
                  </v-row>
                  <!-- <v-row  justify="center" class="mt-4">
                     <v-col cols="12" md="4"
                       style="border:1px solid black" >
                     <button  class="justify-center test ml-5" > Download receipt<v-icon left dark class="ml-3">mdi-cloud-download</v-icon></button>
                     </v-col>
                     </v-row> -->
               </v-card-text>
               <v-card-actions></v-card-actions>
            </v-card>
         </v-container>
      </v-content>
   </div>
</template>
<script>
   import axios from "axios";
   import Header from "../shared/Header";
   export default {
     components: {
       Header: Header,
     },
     data: () => ({
       snackbar_msg: "",
       snackbar: false,
       color: "",
       org: null,
       //
     }),
     watch: {},
     methods: {
       showSnackbar(clr, msg) {
         this.snackbar = true;
         this.color = clr;
         this.snackbar_msg = msg;
       },
     },
     mounted() {
       axios
         .post("/QPTemplate/template")
         .then((res) => {
           if (res.data.msg == "200") {
             //4CAF50
           }
         })
         .catch((error) => {
           this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
         })
         .finally(() => {});
     },
   };
</script>
<style scoped>
   .test {
   border-radius: 2px;
   padding: 6px 20px;
   background: linear-gradient(
   130deg,
   hsla(190, 99%, 30%, 1) 0%,
   hsla(226, 50%, 65%, 1) 180%
   );
   border-color: #3f51b5 !important;
   color: white;
   }
   th,
   td {
   border: 1px solid black;
   }
</style>